<template>
    <div
        class="loader"
        :class="{ 'loader--show': show }"
    >
        <span class="loader__text">{{ $t('loading') }}</span>

        <div class="loader__inner">
            <label class="loader__inner__label">●</label>
            <label class="loader__inner__label">●</label>
            <label class="loader__inner__label">●</label>
            <label class="loader__inner__label">●</label>
            <label class="loader__inner__label">●</label>
            <label class="loader__inner__label">●</label>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, ref } from 'vue'

    export default defineComponent({
        props: {
            show: {
                type: Boolean,
                required: true
            }
        },
        setup(props) {}
    })
</script>
